import ConnectedAccountsPanel from '@/components/ConnectedAccountsPanel';
import PlatformPage from '@/components/platform/PlatformPage';

export default function PlatformSettings() {
  return (
    <PlatformPage
      title="Settings"
      description="Manage how you sign in to the AivoryEMS operator console."
      maxWidth="max-w-2xl"
    >
      <ConnectedAccountsPanel />
    </PlatformPage>
  );
}
